// Единый словарь пользовательских текстов (фаза 6 usability).
//
// Зачем: тексты ошибок/статусов были разбросаны по модулям, дублировались в
// трёх вариантах и протекали тех-жаргоном («MQTT broker», «backend», HTTP-коды,
// тела nginx-страниц). Правила:
//  - здесь — только то, что видит пользователь; технические детали (raw-ошибки
//    библиотек, статусы, тела ответов) уходят в console.*;
//  - словарь закрыт: ни одна функция не возвращает сырую строку ошибки;
//  - тесты сверяются с этими константами, а не с литералами — правка текста
//    больше не ломает тесты по всему репо.

export const TEXT = {
  brain: {
    // Этап 25.1: строка состояния «мозга» (провайдеров LLM) и шторка подробностей.
    line: {
      degraded: 'Основной мозг недоступен — часть моделей отвечает',
      down: 'Мозг недоступен — ответы сейчас не придут',
      // Этап 25.4: только владельцу сервера — лёг выход пула, ответы идут через другой.
      exits: 'Сбой выхода — включён резерв',
    },
    title: 'Состояние мозга',
    explain: {
      ok: 'Все модели отвечают.',
      degraded: 'Основная модель сейчас не отвечает. Чаты на других моделях работают, а основная вернётся сама, как только появится связь.',
      down: 'Ни одна модель сейчас не отвечает — запросы будут завершаться ошибкой. Петрович сам заметит, когда связь вернётся.',
      exits: 'Один из выходов к зарубежным моделям не пропускает запросы. Ответы идут через другой выход, люди этого не замечают.',
    },
    since: 'с',
    loading: 'Проверяем…',
    loadFailed: 'Не удалось получить подробности.',
    providersTitle: 'Провайдеры',
    primary: 'основной',
    // Этап 25.6: короткие подписи моделей (решение владельца) — в строке моделей, шторке и пометке резерва.
    providerNames: { openai: 'OpenAI', zai: 'Z.AI', local: 'Локальная модель', yandex: 'Yandex', home: 'Home' },
    states: { ok: 'отвечает', down: 'не отвечает', unknown: 'нет данных' },
    errors: {
      timeout: 'таймаут', network: 'нет сети до провайдера', auth: 'ключ отклонён',
      rate_limit: 'лимит запросов', server: 'ошибка провайдера', request: 'ошибка запроса',
    },
    lastOk: 'последний ответ',
    // Этап 25.2: под ответом резервного звена цепочки.
    fallbackBadge: 'ответил резерв:',
    fallbackInstead: 'вместо',
    // Этап 25.3: флажок чата — не уходить в российский резерв (YandexGPT).
    noDomesticLabel: 'Не отдавать российскому резерву',
    noDomesticHint: 'Когда OpenAI и Z.AI недоступны, ответы этого чата не пойдут в Yandex — ответит Home, если он на связи, иначе чат подождёт. Модели Yandex в этом чате не выбираются.',
    noDomesticNeedsModel: 'Чат сейчас отвечает моделью Yandex — чтобы включить запрет, сначала выберите модель другого провайдера.',
    lastError: 'ошибка',
    // Этап 25.4: выходы пула в подробностях у владельца.
    exitsTitle: 'Выходы',
    // Этап 25.6: строка моделей у владельца — всегда видна, зелёная точка — модель доступна.
    stripLabel: 'Состояние моделей',
    stripStates: { ok: 'доступна', down: 'недоступна', unknown: 'нет данных' },
    exitNames: { direct: 'Напрямую', exit2: 'Выход №2', nl: 'NL-хост' },
    // Этап 33: владельцу — новые модели у провайдеров (чип на строке моделей) и
    // модели цепочек и служебных вызовов, которых у провайдера нет.
    newModels: 'новые:',
    newModelsLabel: 'Новые модели у провайдеров',
    catalogLink: 'Модели провайдеров',
    warningsTitle: 'Нет у провайдера',
    warningReasons: {
      missing: 'пропала у провайдера',
      never_listed: 'нет в списке провайдера',
      // Этап 33.2: основная пропала у провайдера — её заменила другая.
      default_replaced: 'была основной и пропала у провайдера — основной стала',
    },
    close: 'Закрыть',
  },
  connection: {
    // Состояния соединения (баннер ConnectionStatus, mqtt.js).
    connecting: 'Подключаемся…',
    reconnecting: 'Восстанавливаем связь…',
    disconnected: 'Нет связи с сервером — восстанавливаем…',
    lost: 'Связь прервалась — восстанавливаем…',
    error: 'Не удалось подключиться — пробуем ещё раз…',
    browserOffline: 'Нет сети. Сообщения отправятся при появлении связи.',
    serverSilent: 'Сервер не отвечает — пробуем переподключиться…',
    tls: 'Защищённое соединение не установилось.',
    accessDenied: 'Нет доступа к чату — обратитесь к администратору.',
    connectFailed: 'Не удалось подключиться к серверу.',
    // В8 (1.27.2): плашка — кнопка немедленной попытки.
    retryNow: 'Повторить',
    retryNowAria: 'Переподключиться сейчас',
  },
  api: {
    network: 'Нет связи с сервером. Проверьте интернет и повторите.',
    timeout: 'Сервер не ответил. Проверьте связь и повторите.',
    serverBusy: 'Сервер временно недоступен.',
    sessionExpired: 'Сессия истекла — входим заново…',
    forbidden: 'Доступ закрыт. Откройте приложение с вашего устройства.',
    chatMissing: 'Чат удалён или недоступен.',
  },
  bootstrap: {
    resumeFailed: 'Не получилось восстановить работу. Обновите страницу.',
    startFailed: 'Не получилось запуститься.',
  },
  family: {
    // Семейные чаты (этап 7.1): шаринг, участники, события состава.
    shareTitle: 'Поделиться чатом',
    shareWarning: 'Участники увидят всю переписку. Петрович помнит всю историю чата и может ссылаться на неё.',
    shareFromNow: 'Показывать историю только с этого момента',
    shareSubmit: 'Поделиться',
    shareEmptyRoster: 'В семье пока нет других пользователей.',
    shareFailed: 'Не получилось поделиться чатом. Повторите.',
    membersTitle: 'Участники',
    memberRemove: 'Убрать',
    memberRemoveConfirm: 'Точно убрать?',
    memberRemoveFailed: 'Не получилось убрать участника. Повторите.',
    leaveChat: 'Выйти из чата',
    leaveConfirm: 'Выйти из общего чата? Он исчезнет из вашего списка.',
    leaveFailed: 'Не получилось выйти из чата. Повторите.',
    sharedBadge: 'Общий',
    chatDeletedByOwner: 'Владелец удалил этот чат.',
    removedFromChat: 'Вас убрали из этого чата.',
    ownerLabel: 'Владелец',
    // Петрович в общем чате (этап 7.2)
    assistantName: 'Петрович',
    mentionToken: '@Петрович',
    mentionModeHint: 'Теперь Петрович отвечает только по упоминанию @Петрович. Изменить — в настройках чата.',
    replyToAssistant: 'Ответить Петровичу',
    composerMentionPlaceholder: 'Сообщение… (@Петрович — позвать)',
    composerAssistantPlaceholder: 'Сообщение Петровичу…',
    callAssistant: 'Позвать Петровича',
    callAssistantActive: 'Сообщение уйдёт Петровичу',
    sendToAssistantHint: 'Долгое нажатие — отправить Петровичу',
    responseModeLabel: 'Петрович отвечает',
    responseModeAll: 'На все сообщения',
    responseModeMention: 'Только по упоминанию @Петрович',
    responseModeHint: 'Действует только в общем чате. В личном чате Петрович отвечает всегда.',
    // Прочтение и «печатает…» (этап 7.3)
    readByAll: 'Прочитано всеми',
    typingOne: '{name} печатает…',
    typingMany: 'Печатают: {names}…',
    unreadAria: 'Непрочитанных: {count}',
    // Уведомления по чату (этап 12): выключены по умолчанию, включаются точечно.
    enableNotifications: 'Включить уведомления',
    disableNotifications: 'Выключить уведомления',
    notificationsBadge: 'Уведомления включены',
    notificationsFailed: 'Не получилось изменить уведомления. Повторите.',
    // В12 (1.27.6): включение уведомлений чата одним тапом — итог по состоянию устройства.
    notificationsOn: 'Уведомления включены — придут на это устройство, даже когда приложение закрыто.',
    notificationsDenied: 'Уведомления для чата включены, но iPhone запретил их приложению: Настройки → Петрович → Уведомления.',
    notificationsNeedInstall: 'Уведомления для чата включены. На iPhone они приходят только в приложении с экрана «Домой».',
    notificationsNoPush: 'Уведомления для чата включены, но на это устройство push не приходит — только пока приложение открыто.',
  },
  // В6, В14 (1.27.6): настройки сохраняются сразу, параметры модели — в «Для опытных».
  settings: {
    autosaveHint: 'Изменения сохраняются сразу.',
    saving: 'Сохраняю…',
    saved: 'Сохранено',
    saveFailed: 'Не сохранилось. Повторите.',
    promptHint: 'Определяет базовое поведение и роль ассистента в этом чате. Сохраняется, когда вы уходите из поля.',
    advancedTitle: 'Для опытных',
    advancedHint: 'Действуют на все ваши чаты. Если не уверены — не меняйте.',
    defaultModelLabel: 'Модель по умолчанию',
    defaultModelHint: 'Для новых чатов, если в чате не выбрана другая.',
    temperatureLabel: 'Креативность ответов',
    temperatureHint: '0 — строго и одинаково, 2 — свободно и неожиданно. Рекомендуется 0,7.',
    maxTokensLabel: 'Предел длины ответа, токенов',
    maxTokensHint: 'Маленькое число обрывает ответы во всех чатах. Рекомендуется максимум.',
    resetDefaults: 'Вернуть рекомендуемые',
    contextReset: 'Контекст сброшен.',
  },
  list: {
    // Общий список чата (этап 8): панель, шторка «+», список чатов.
    panelTitle: 'Список',
    newChat: 'Список',
    badge: 'Список',
    filter: 'Списки',
    summary: '{done} из {total}',
    empty: 'Список пуст — добавьте первый пункт.',
    addPlaceholder: 'Добавить пункт',
    addSubmit: 'Добавить',
    collapse: 'Свернуть список',
    expand: 'Развернуть список',
    clearDone: 'Очистить отмеченные',
    clearDoneConfirm: 'Точно убрать отмеченные?',
    itemActions: 'Действия с пунктом',
    removeItem: 'Удалить пункт',
    addedByAssistant: 'Добавил Петрович',
    addedBy: 'Добавил: {name}',
    doneBy: 'Отметил: {name}',
    readOnly: 'Чат в архиве — список только для чтения.',
    addFailed: 'Не получилось добавить пункт. Повторите.',
    updateFailed: 'Не получилось изменить пункт. Повторите.',
    removeFailed: 'Не получилось удалить пункт. Повторите.',
    clearFailed: 'Не получилось очистить список. Повторите.',
  },
  push: {
    // Web Push (этап 7.5): экран общих настроек.
    title: 'Push-уведомления',
    unsupported: 'Push-уведомления в этом браузере не поддерживаются.',
    needInstall: 'На iPhone push работает только у приложения, добавленного на экран «Домой». Откройте его оттуда и включите здесь.',
    serverDisabled: 'Push на сервере не настроен.',
    enabled: 'Включены на этом устройстве.',
    disabled: 'Выключены на этом устройстве.',
    denied: 'Доступ к уведомлениям запрещён в настройках браузера.',
    enable: 'Включить на этом устройстве',
    disable: 'Отключить',
    sendTest: 'Отправить тестовое',
    testSent: 'Тестовое уведомление отправлено.',
    hint: 'По умолчанию уведомления по чатам выключены — включайте нужные в меню чата. Приходят: сообщения участников и ответы Петровича в общих чатах, готовый ответ Петровича в личном.',
    failed: 'Не получилось изменить push-уведомления. Повторите.',
    // Этап 28: плашка в списке чатов, когда iOS сбросила разрешение на уведомления.
    bannerText: 'Уведомления на этом устройстве выключены.',
    bannerEnable: 'Включить',
    bannerDismiss: 'Не нужно',
    restored: 'Уведомления снова приходят на это устройство.',
    restoreDenied: 'Уведомления запрещены в настройках устройства. На iPhone: Настройки → Петрович → Уведомления.',
  },
  chat: {
    // Этап 31: картинку из истории (ссылку) не удалось скачать для повторной отправки.
    imageFetchFailed: 'Не получилось подготовить картинку к отправке. Проверьте связь и повторите.',
    // Строка статуса генерации (В9, 1.27.8): «получено», «в очереди» и «обработка»
    // больше не сливаются в одно «Отправлено».
    statusSent: 'Отправлено',
    statusQueued: 'В очереди…',
    statusThinking: 'Думает…',
    statusThinkingFor: 'Думает… {seconds} с',
    statusStreaming: 'Печатает…',
    statusCancelled: 'Отменено',
    statusDone: 'Ответ получен',
    statusErrorPrefix: 'Ошибка:',
    // В7 (1.27.6): сброс контекста — прямо в меню чата, подтверждение внутри шторки.
    resetContextAction: 'Сбросить контекст',
    resetContextConfirm: 'Сбросить контекст? Сообщения останутся в ленте, но новые ответы Петрович будет давать без них.',
    resetContextFailed: 'Не получилось сбросить контекст. Повторите.',
    // В13 (1.27.8): удаление места поездки и фрагмента скана — вторым касанием.
    deleteArmed: 'Точно удалить?',
    // 1.27.0: недописанный ответ остаётся в ленте с пометкой.
    stoppedBadge: 'Остановлено',
    stoppedTitle: 'Ответ остановлен — дальше Петрович не писал',
    interruptedBadge: 'Оборвано',
    interruptedTitle: 'Ответ оборвала ошибка — можно ответить заново',
    // 1.27.0: быстрые действия под последним ответом и повтор без ответа.
    quickActionsAria: 'Действия с ответом',
    copyAction: 'Копировать',
    copied: 'Текст скопирован.',
    copyFailed: 'Не получилось скопировать.',
    regenerateAction: 'Ещё раз',
    regenerateAria: 'Ответить заново',
    retryAction: 'Повторить',
    retryAria: 'Получить ответ заново',
    regenerateFailed: 'Не получилось отправить. Проверьте связь и повторите.',
    shareAction: 'Поделиться',
    copyAnswerAria: 'Скопировать ответ',
    shareAnswerAria: 'Поделиться ответом',
    // К5 (1.27.7): фото из очереди не пережило перезагрузку приложения.
    photoLost: 'Фото не сохранилось',
    reattach: 'Прикрепить заново',
    reattachAria: 'Вернуть текст в поле ввода и выбрать фото заново',
    // Пункт «Ответить» (1.27.0): цитата сообщения встаёт в начало черновика.
    replyAction: 'Ответить',
    replyImageQuote: '[картинка]',
    // Навигация по ленте (этап 13): плавающие кнопки «Вверх»/«Вниз».
    scrollDownAria: 'К последним сообщениям',
    scrollUpAria: 'Экран вверх, удерживайте для перехода в начало истории',
    scrollUpTitle: 'Тап — экран вверх, удержание — в начало истории',
    scrollUpHint: 'Кнопка «вверх»: тап листает на экран, удержание ведёт в начало истории.',
    jumpToStartFailed: 'Не получилось открыть начало истории. Повторите.',
    // Удаление сообщений (этап 15): удаление физическое и необратимое.
    deleteAction: 'Удалить',
    deleteConfirm: 'Удалить сообщение вместе с ответом? Восстановить не получится.',
    deleteAboveAction: 'Удалить всё выше',
    deleteAboveConfirm: 'Удалить всю историю выше этого сообщения? Восстановить не получится.',
    deleteAboveDone: 'История выше удалена.',
    // 1.23.3: «Удалить всё ниже» — зеркало «всё выше», обмен остаётся, хвост уходит.
    deleteBelowAction: 'Удалить всё ниже',
    deleteBelowConfirm: 'Удалить всю историю ниже этого обмена? Восстановить не получится.',
    deleteBelowDone: 'История ниже удалена.',
    // Поджатое меню (1.23.3): редкие действия и удаление — в подменю.
    moreAction: 'Ещё…',
    deleteGroup: 'Удалить…',
    sheetBack: 'Назад',
    deleteFailed: 'Не получилось удалить. Повторите.',
    deleteBusy: 'Идёт генерация — дождитесь ответа и повторите.',
    // Выделение текста (1.23.1): просмотр сообщения с нативным выделением и копированием.
    selectTextAction: 'Выделить текст',
    selectTextTitle: 'Текст сообщения',
    selectTextCopyAll: 'Скопировать всё',
    selectTextDone: 'Готово',
  },
  auth: {
    // Этап 16: вход без сертификата — экран входа, устройства, приглашение, passkey.
    loginTitle: 'Вход',
    loginLead: 'Сессия закончилась. Войдите по Face ID, по коду приглашения или по сертификату.',
    loginPasskey: 'Войти по Face ID',
    loginCertificate: 'Войти по сертификату',
    loginPasskeyUnsupported: 'На этом устройстве вход по Face ID недоступен — войдите по сертификату.',
    loginFailed: 'Не получилось войти по Face ID. Попробуйте ещё раз или войдите по сертификату.',
    // iOS отвечает одной ошибкой и на отмену, и на «ключа нет» — подсказываем код.
    loginCancelled: 'Вход не выполнен. Если на этом устройстве нет ключа Face ID, войдите по коду приглашения.',
    // К3 (1.27.2): код приглашения можно ввести руками — раньше его принимала только ссылка из QR.
    loginCodeLabel: 'Код приглашения',
    loginCodePlaceholder: 'Например, K7QX2M8P',
    loginCodeSubmit: 'Войти по коду',
    loginCodeHint: 'Код покажут на устройстве, где Петрович уже работает: Настройки → «Устройства и вход» → «Показать код».',
    loginBusy: 'Входим…',
    devicesTitle: 'Устройства и вход',
    devicesLead: 'Здесь ваши устройства с доступом к Петровичу. Отзыв закрывает вход с устройства сразу.',
    devicesEmpty: 'Устройств пока нет.',
    deviceCurrent: 'это устройство',
    deviceHasPasskey: 'Face ID',
    deviceRevoke: 'Отозвать',
    deviceRevokeConfirm: 'Отозвать доступ с этого устройства? Ему придётся войти заново — по Face ID, коду или сертификату.',
    deviceRevokeCurrentConfirm: 'Это ваше текущее устройство. Отозвать — значит выйти; войти обратно можно по Face ID. Продолжить?',
    passkeysTitle: 'Ключи Face ID',
    passkeyItemTitle: 'Ключ Face ID',
    passkeyForDevice: 'для устройства',
    passkeyDeviceSignedOut: 'устройство вышло, ключ действует',
    passkeyDelete: 'Удалить ключ',
    passkeyDeleteConfirm: 'Удалить ключ с сервера? Вход по нему станет невозможен. На устройстве ключ останется — удалите его в настройках iOS (Пароли).',
    passkeyDeleted: 'Ключ удалён с сервера.',
    passkeyDeleteFailed: 'Не получилось удалить ключ. Повторите.',
    deviceRevoked: 'Доступ отозван.',
    deviceRevokeFailed: 'Не получилось отозвать. Повторите.',
    passkeyEnable: 'Включить вход по Face ID',
    passkeyEnabled: 'Вход по Face ID включён на этом устройстве.',
    passkeyEnabledOther: 'Ключ добавлен.',
    passkeyUnsupported: 'На этом устройстве Face ID для входа недоступен.',
    passkeyFailed: 'Не получилось включить Face ID. Повторите.',
    passkeyCancelled: 'Настройка отменена.',
    passkeySetupPrompt: 'Устройство добавлено. Включить вход по Face ID, чтобы больше не сканировать код?',
    passkeyHint: 'Ключ хранится в связке ключей устройства и синхронизируется через iCloud. Сертификат остаётся запасным входом.',
    inviteTitle: 'Добавить устройство',
    inviteLead: 'Покажите код новому устройству: наведите его камеру на QR или введите код вручную. Код одноразовый и действует несколько минут.',
    inviteCreate: 'Показать код',
    inviteCreateFor: 'Код для другого пользователя',
    inviteUserPlaceholder: 'Идентификатор пользователя',
    inviteExpires: 'Действует до',
    inviteManual: 'Или введите на новом устройстве:',
    inviteLink: 'Открыть ссылку на новом устройстве',
    inviteLimit: 'Слишком много активных кодов. Дождитесь истечения предыдущих.',
    inviteForbidden: 'Приглашать других пользователей может только владелец сервера.',
    inviteUnknownUser: 'Такого пользователя нет.',
    inviteFailed: 'Не получилось создать код. Повторите.',
    inviteDone: 'Готово.',
  },
  chats: {
    // Закрепление чата сверху (этап 11): меню, секция ленты, ошибки.
    pinAction: 'Закрепить сверху',
    unpinAction: 'Открепить',
    pinnedSection: 'Закреплённые',
    pinnedListAria: 'Закреплённые чаты',
    otherListAria: 'Остальные чаты',
    pinnedBadge: 'Закреплён',
    pinLimit: 'Можно закрепить не больше трёх чатов. Открепите один — и закрепляйте новый.',
    pinFailed: 'Не получилось закрепить чат. Повторите.',
    unpinFailed: 'Не получилось открепить чат. Повторите.',
    // К4 (1.27.2): сбой загрузки списка — не «чатов нет».
    loadFailed: 'Не удалось загрузить чаты. Проверьте связь и повторите.',
    loadRetry: 'Повторить',
    // Дата последнего сообщения в строке списка (1.27.2): по календарным дням.
    yesterday: 'вчера',
    // Жесты строки списка (В5, 1.27.3): свайп влево — архив, вправо — закрепление.
    archived: 'Чат в архиве.',
    undo: 'Отменить',
    swipeArchive: 'В архив',
    swipeUnarchive: 'Вернуть',
    swipePin: 'Закрепить',
    swipeUnpin: 'Открепить',
  },
  dacha: {
    // Дача как второй мозг (этап 10): экран контекста, бейджи, статусы.
    badge: 'Дача',
    contextTitle: 'Контекст чата',
    contextButton: 'Контекст чата',
    backToChat: 'Назад в чат',
    brainLabel: 'Мозг чата',
    brainCloud: 'Облако',
    brainCloudHint: 'Обычный Петрович: облачная модель и настройки этого чата.',
    brainDacha: 'Дача',
    brainDachaHint: 'Петрович на даче: датчики, свет, камеры, погода и память дома. Модель выбирает дача, настройки чата на неё не влияют.',
    brainReadOnly: 'Мозг чата выбирает владелец. Сейчас: {brain}.',
    brainSaved: 'Сохранено',
    brainSaveFailed: 'Не получилось переключить мозг чата. Повторите.',
    brainDisabled: 'Дача не подключена на сервере.',
    brainOfflineWarning: 'Дача сейчас не на связи: ответы придут, когда связь появится. Переключить всё равно можно.',
    cardTitle: 'Дача',
    online: 'На связи',
    offline: 'Нет связи',
    lastSeen: 'последний сигнал {minutes} мин назад',
    lastSeenNow: 'последний сигнал только что',
    lastSeenNever: 'сигналов ещё не было',
    notEnabled: 'Дача не подключена на сервере.',
    statusFailed: 'Не получилось узнать состояние дачи.',
    rooms: 'Комнаты',
    tools: 'Инструментов: {count}',
    refreshSummary: 'Обновить сводку',
    summaryLoading: 'Спрашиваю дачу…',
    summaryAlerts: 'Алерты',
    summarySensors: 'Датчики',
    summaryUpdated: 'Обновлено {time}',
    summaryFailed: 'Не получилось получить сводку. Повторите.',
    summaryOffline: 'Дача не на связи — сводка недоступна.',
    hint: 'Свайп влево из чата открывает этот экран, свайп вправо возвращает в чат.',
  },
  about: {
    // Версия сборки (2026-09-18): на устройстве нужно понимать, что именно стоит,
    // и отличать собранное от того, что закэшировал service worker.
    appName: 'Петрович',
    buildPrefix: 'сборка',
    copied: 'Версия скопирована.',
    copyHint: 'Нажмите, чтобы скопировать',
  },
  stages: {
    // Этапы проекта (этап 23): карточка конспекта, закрытие, окно этапа, сводка, память.
    cardTitle: 'Этап',
    cardMeta: '{count} сообщений · {range}',
    pending: 'Петрович пишет конспект…',
    failed: 'Конспект не написался: {error}',
    hiddenSummary: 'Конспект скрыт: этап начался до вашего приглашения.',
    carryOverTitle: 'Хвосты этапа',
    carryOverToComposer: 'В композер',
    carryOverPrefix: 'Продолжаем после этапа «{title}»:',
    // Шторка карточки.
    openMessages: 'Открыть сообщения',
    askWith: 'Спросить с этим этапом',
    editSummary: 'Править конспект',
    regenerate: 'Пересобрать',
    regenerateConfirm: 'Пересобрать конспект? Ваши правки будут учтены.',
    regenerateFromScratch: 'Пересобрать с нуля',
    regenerateFromScratchConfirm: 'Пересобрать без учёта ваших правок? Название снова предложит модель.',
    retry: 'Повторить',
    reopen: 'Раскрыть этап',
    reopenConfirm: 'Раскрыть этап? Сообщения вернутся в ленту, конспект удалится.',
    // Закрытие.
    closeAction: 'Закрыть этап…',
    closeTitlePlaceholder: 'Название этапа (необязательно)',
    closeSubmit: 'Закрыть этап',
    closeQueued: 'Этап закрыт, Петрович пишет конспект.',
    closeFailed: 'Не получилось закрыть этап. Повторите.',
    closeBusy: 'Идёт генерация — дождитесь ответа и повторите.',
    closePending: 'Конспект или сводка ещё пишутся — подождите.',
    closeNothing: 'Сворачивать пока нечего: слишком мало реплик.',
    closeDacha: 'В дачном чате этапов нет.',
    // Плашка (реш. 9).
    hintText: 'Начало этапа уже вне памяти Петровича.',
    hintFold: 'Свернуть',
    hintDismiss: 'Скрыть',
    // Окно этапа.
    windowTitle: 'Этап «{title}»',
    windowBack: 'Вниз',
    windowOpenFailed: 'Не получилось открыть этап. Повторите.',
    sourceMissing: 'Сообщение-источник удалено — открыт весь этап.',
    // Правка конспекта.
    editTitle: 'Правка конспекта',
    editTitleLabel: 'Название',
    editSummaryLabel: 'Конспект',
    editLinksHint: 'Маркеры [#12] — ссылки на сообщения-источники: их можно удалить, новые не добавить.',
    editSave: 'Сохранить',
    editSaved: 'Конспект сохранён.',
    editFailed: 'Не получилось сохранить конспект. Повторите.',
    regenerateQueued: 'Пересобираю конспект…',
    reopened: 'Этап раскрыт.',
    actionFailed: 'Не получилось. Повторите.',
    // Вложение этапа (реш. 22).
    includeChip: '+ Этап «{title}» целиком',
    includeRemove: 'Убрать этап из запроса',
    includeLimit: 'Вложить можно не больше {count} этапов.',
    // Экран контекста.
    contextTitle: 'Этапы',
    contextEmpty: 'Этапов пока нет. Закрыть этап можно из меню чата, когда разговор подошёл к итогу.',
    contextLive: 'Живых реплик: {count} из {limit}',
    contextClose: 'Закрыть этап…',
    contextDacha: 'В дачном чате этапов нет.',
    contextBrainBlocked: 'Чтобы переключить на дачу, раскройте этапы.',
    templateLabel: 'Шаблон конспекта',
    templateProject: 'Проект',
    templateResearch: 'Исследование',
    templateTrip: 'Поездка',
    templateCustom: 'Свой',
    templateCustomPlaceholder: 'Перечислите разделы конспекта после «Итога»…',
    templateSaved: 'Сохранено',
    templateFailed: 'Не получилось сохранить шаблон. Повторите.',
    templateCustomRequired: 'Для своего шаблона нужен текст разделов.',
    stateTitle: 'Состояние проекта',
    stateResearchTitle: 'Состояние исследования',
    stateTripTitle: 'Состояние поездки',
    stateEmpty: 'Сводка появится после первого закрытого этапа.',
    statePending: 'Петрович обновляет сводку…',
    stateFailed: 'Сводка не обновилась: {error}. Текст остался прежним.',
    stateHidden: 'Сводка скрыта: проект начался до вашего приглашения.',
    stateEdit: 'Править',
    stateSave: 'Сохранить',
    stateCancel: 'Отмена',
    stateRegenerate: 'Пересобрать сводку',
    stateRegenerateFromScratch: 'Пересобрать с нуля',
    stateClear: 'Очистить',
    stateClearConfirm: 'Очистить сводку? Она снова появится после следующего закрытого этапа.',
    // В13 (1.27.8): «с нуля» стирает ручные правки сводки — второе касание.
    stateRegenerateFromScratchConfirm: 'С нуля — ваши правки пропадут. Точно?',
    stateSaved: 'Сводка сохранена.',
    stateFailedSave: 'Не получилось сохранить сводку. Повторите.',
    stateBusy: 'Конспект или сводка ещё пишутся — подождите.',
    memoryTitle: 'Память проекта',
    memoryStages: 'Этапов: {count}',
    memoryChars: 'Сводка и конспекты: {chars} знаков (~{tokens} токенов), {percent}% бюджета',
    memoryTrimmed: 'Ужато до итога: {count}',
    memoryDropped: 'Выпало из памяти: {count}',
    memoryWarning: 'Старые этапы Петрович помнит только по итогу и сводке.',
  },
  publish: {
    // Публикация чата в свой git и на сайт MkDocs (этап 26). Видит только владелец сервера.
    menuPublish: 'Опубликовать…',
    menuManage: 'Публикация',
    title: 'Публикация на сайте',
    intro: 'Раздел чата на вашем сайте: сводка и конспекты этапов. Правка страницы в git вернётся сюда, и Петрович будет помнить исправленное.',
    treeTitle: 'Что появится на сайте',
    treeOverview: 'Обзор — «Состояние проекта»',
    treeOverviewEmpty: 'Обзор — сводка появится после первого этапа',
    treeTranscript: 'Расшифровка переписки',
    noStages: 'В чате нет закрытых этапов — на сайте будет только обзор и расшифровка.',
    closeAndPublish: 'Закрыть этап и опубликовать',
    includeTranscript: 'Расшифровка переписки',
    includeTranscriptHint: 'Реплики с картинками; ссылки [#n] из конспектов ведут на них.',
    autoStages: 'Публиковать новые этапы',
    autoStagesHint: 'Выключено — на сайте останутся этапы, что уже там.',
    publish: 'Опубликовать',
    publishing: 'Публикую…',
    openSite: 'Открыть на сайте',
    openGit: 'Открыть в git',
    syncNow: 'Обновить сейчас',
    unpublish: 'Снять с публикации',
    unpublishConfirm: 'Снять раздел с сайта? В истории git он останется.',
    unpublished: 'Раздел снят с сайта.',
    published: 'Чат опубликован.',
    failed: 'Не удалось опубликовать.',
    commitsTitle: 'Последние изменения',
    conflictsTitle: 'Правили с двух сторон',
    conflictHint: 'Эту страницу изменили и в git, и здесь. Выберите, какую версию оставить.',
    unparsedHint: 'Правку в git не разобрать (сломана служебная шапка или страница пустая). Можно вернуть версию Петровича.',
    compare: 'Сравнить',
    versionGit: 'В git',
    versionPetrovich: 'В Петровиче',
    keepGit: 'Оставить из git',
    keepPetrovich: 'Оставить из Петровича',
    back: 'Назад',
    // Значок в строке под названием чата.
    badge: {
      synced: 'Опубликован',
      syncing: 'Синхронизируется…',
      imported: 'Правка из git',
      conflict: 'Конфликт',
      error: 'Ошибка публикации',
    },
    status: {
      synced: 'Синхронизировано {time}',
      pending: 'Публикуется…',
      conflict: 'Есть страницы, правленные с двух сторон',
      error: 'git не ответил: {error}',
    },
    importedStage: 'Конспект этапа {number} изменён в git',
    importedState: 'Сводка изменена в git',
    importedMark: 'изменено в git · {time}',
    pageState: 'Обзор',
    pageStage: 'Этап {number}',
    pageTranscript: 'Расшифровка',
    importedArticle: 'Статья изменена в git',
    // Статья о проекте из сводки и конспектов (этап 26.5).
    article: {
      title: 'Статья о проекте',
      hint: 'Петрович напишет статью по сводке и конспектам: решения, почему их приняли, что осталось. Перед публикацией вы увидите её целиком.',
      noSources: 'Статью пока не из чего собрать: закройте этап — появятся конспект и сводка.',
      generate: 'Собрать статью',
      regenerate: 'Пересобрать статью',
      pending: 'Петрович пишет статью…',
      draftReady: 'Статья готова — посмотрите её перед публикацией.',
      preview: 'Посмотреть',
      previewHint: 'Так статья уйдёт на сайт. Врезки и вкладки на сайте оформлены, здесь — упрощённо.',
      accept: 'Опубликовать статью',
      discard: 'Отказаться',
      discardConfirm: 'Точно отказаться от статьи?',
      failed: 'Статья не собралась: {error}',
      retry: 'Попробовать снова',
      published: 'Статья на сайте',
      open: 'Открыть статью',
      stale: 'После сборки закрылись новые этапы или изменилась сводка — статью стоит пересобрать.',
      onSite: 'Статья на сайте',
      readyToast: 'Статья готова — откройте публикацию, чтобы посмотреть.',
      failedToast: 'Статья не собралась.',
    },
    admonitions: {
      note: 'Заметка', tip: 'Совет', warning: 'Внимание', question: 'Вопрос', info: 'Информация',
      danger: 'Опасно', success: 'Готово', example: 'Пример', quote: 'Цитата', abstract: 'Кратко',
    },
  },
  modelPicker: {
    // Шторка выбора модели из шапки чата (1.25.7): тап по названию модели → список
    // по провайдерам, тап по модели — сразу сохраняет её для чата.
    title: 'Модель чата',
    open: 'Сменить модель',
    recent: 'Недавние',
    current: 'выбрана',
    settings: 'Все настройки чата',
    failed: 'Не удалось сменить модель.',
    domesticRefused: 'Модели Yandex недоступны: в настройках чата запрещён российский резерв.',
    domesticHint: 'недоступна: чат не отдаётся российским моделям',
    images: 'видит картинки',
    // Состояния — только владельцу сервера (как строка моделей).
    states: {
      ok: 'доступна',
      down: 'недоступна — ответит резерв',
      unknown: 'нет данных',
      limit: 'лимит на сегодня исчерпан — ответит резерв',
    },
    // Человеческие названия; для моделей вне списка название собирается из имени
    // (этап 33, model-picker.js → modelLabel): «gpt-6.1-sol» → «GPT-6.1 Sol».
    names: {
      'openai:gpt-5.6-terra': 'GPT-5.6 Terra',
      'openai:gpt-5.6-sol': 'GPT-5.6 Sol',
      'openai:gpt-5.6-luna': 'GPT-5.6 Luna',
      'openai:gpt-6-astra': 'GPT-6 Astra',
      'zai:glm-5.3': 'GLM-5.3',
      'zai:glm-5.3-flash': 'GLM-5.3 Flash',
      'yandex:yandexgpt-5.1/latest': 'YandexGPT 5.1',
      'yandex:yandexgpt/latest': 'YandexGPT',
      'yandex:yandexgpt-lite/latest': 'YandexGPT Lite',
      'yandex:aliceai-llm/latest': 'Alice AI',
      'yandex:deepseek-v4.1-flash/latest': 'DeepSeek V4.1 Flash',
      'yandex:qwen3-235b-a22b-fp8/latest': 'Qwen3 235B',
      'home:qwen3.8-4b': 'Qwen3.8 4B',
    },
  },
  modelCatalog: {
    // Этап 33: шторка «Модели провайдеров» у владельца сервера — что отдают
    // `GET /models` провайдеров; 33.2 — включение, выключение, основная модель.
    title: 'Модели провайдеров',
    intro: 'Модели, которые провайдеры отдают сейчас. Включённые видят все в выборе модели. Перед включением Петрович проверяет модель пробным запросом.',
    loading: 'Загружаем список…',
    loadFailed: 'Не удалось загрузить список моделей.',
    retry: 'Повторить',
    listedAt: 'список от',
    noList: 'провайдер ещё не отдал список',
    empty: 'Моделей нет.',
    chats: 'чатов:',
    tags: {
      default: 'основная',
      enabled: 'в выборе',
      new: 'новая',
      images: 'видит картинки',
      notLoaded: 'не загружена',
      missing: 'нет у провайдера с',
    },
    // Этап 33.2: управление каталогом выбора.
    toggleLabel: 'в выборе',
    checking: 'Проверяем модель…',
    saving: 'Сохраняем…',
    outputLimit: 'предел ответа:',
    replacedBy: 'чаты переведены на',
    checkFailedAt: 'не прошла проверку:',
    makeDefault: 'Сделать основной',
    confirmDisable: 'Выключить',
    cancel: 'Отмена',
    moveTo: 'перейдут на',
    moveToOne: 'перейдёт на',
    and: 'и',
    // Склонения: одна, две, пять.
    forms: {
      chats: ['чат', 'чата', 'чатов'],
      templates: ['шаблон', 'шаблона', 'шаблонов'],
      users: ['человека', 'человек', 'человек'],
    },
    usersPrefix: 'настройки',
    // Итог пробного запроса (llm/model_check.py).
    checkErrors: {
      timeout: 'модель не ответила вовремя',
      network: 'нет связи с провайдером',
      auth: 'ключ не подходит к этой модели',
      rate_limit: 'провайдер ограничил запросы — попробуйте позже',
      server: 'ошибка провайдера — попробуйте позже',
      rejected: 'провайдер отклонил запрос: модель не работает в чате через наш API',
      empty: 'модель вернула пустой ответ',
    },
    // Отказы backend (detail.code ответа PATCH /api/models/catalog).
    errors: {
      default_locked: 'Основную модель выключить нельзя — сначала сделайте основной другую.',
      missing: 'Модели нет у провайдера.',
      no_key: 'У провайдера нет ключа.',
      check_in_progress: 'Проверка уже идёт.',
      not_enabled: 'Сначала включите модель.',
      unknown_model: 'Модель неизвестна — обновите список.',
      failed: 'Не удалось изменить каталог.',
    },
    // Роли модели в конфигурации сервера: цепочки резерва и служебные вызовы.
    roles: {
      chain_chat: 'резерв ответа',
      chain_vision: 'резерв зрения',
      chain_detect: 'резерв классификаторов',
      vision: 'зрение',
      search: 'веб-поиск',
      image: 'генерация картинок',
      intent: 'классификатор',
      travel: 'классификатор',
      list: 'классификатор',
      title: 'заголовки чатов',
      summary: 'конспекты',
    },
    showHidden: 'Показать скрытые',
    hideHidden: 'Скрыть лишние',
    hiddenHint: 'Не для чата: эмбеддинги, речь, картинки, снимки с датой.',
    close: 'Закрыть',
  },
  templates: {
    // Библиотека шаблонов чата (этап 24): имя + промпт + пресет конспекта + модель.
    title: 'Библиотека шаблонов',
    back: 'Назад',
    fromLibrary: 'Из библиотеки…',
    openLibrary: 'Библиотека…',
    empty: 'Шаблонов пока нет. Добавьте пример ниже или сохраните настройки любого чата как шаблон.',
    examplesTitle: 'Примеры',
    addExample: 'Добавить',
    newTemplate: 'Новый шаблон',
    nameLabel: 'Название',
    namePlaceholder: 'Например, «Ремонт»',
    promptLabel: 'Системный промпт',
    presetLabel: 'Шаблон конспекта',
    presetCustomPlaceholder: 'Перечислите разделы конспекта после «Итога»…',
    modelLabel: 'Модель',
    modelDefault: 'Модель по умолчанию',
    modelMissing: 'Модели нет в каталоге — чат получит модель по умолчанию',
    save: 'Сохранить',
    cancel: 'Отмена',
    edit: 'Изменить',
    delete: 'Удалить',
    deleteConfirm: 'Удалить шаблон? Созданные из него чаты останутся.',
    newChat: 'Новый чат из шаблона',
    saved: 'Шаблон сохранён.',
    deleted: 'Шаблон удалён.',
    created: 'Чат создан из шаблона.',
    lastUsed: 'Использован {date}',
    neverUsed: 'Ещё не использовался',
    nameTaken: 'Шаблон с таким именем уже есть.',
    limit: 'Слишком много шаблонов — удалите ненужные.',
    customRequired: 'Для своего шаблона нужен текст разделов.',
    missing: 'Шаблон уже удалён — список обновлён.',
    failed: 'Не получилось. Повторите.',
    loadFailed: 'Не удалось загрузить библиотеку.',
    // Экран настроек чата.
    saveAsTemplate: 'Сохранить как шаблон',
    applyTemplate: 'Применить шаблон',
    applyConfirm: 'Заменить промпт этого чата промптом шаблона?',
    applied: 'Шаблон применён.',
    createdFrom: 'Создан из шаблона «{name}»',
    noTemplates: 'В библиотеке пока нет шаблонов.',
    // Ссылка из общих настроек.
    settingsLink: 'Библиотека шаблонов',
    settingsHint: 'Промпт и шаблон конспекта под именем: новый чат за два тапа.',
    // Стартовые примеры (живут на клиенте, в базу попадают по тапу).
    examples: [
      {
        key: 'project',
        name: 'Проект',
        stageTemplate: 'project',
        systemPrompt: 'Ты — помощник по домашнему проекту (ремонт, стройка, переезд). Цель, бюджет и сроки проекта я назову в первых сообщениях — держи их в уме. Каждое принятое решение фиксируй явно: что решили и почему. Числа, размеры и суммы повторяй дословно. Если что-то отложили — напоминай об этом, когда придёт время.',
      },
      {
        key: 'research',
        name: 'Исследование',
        stageTemplate: 'research',
        systemPrompt: 'Ты — помощник в исследовании. Вопрос исследования и критерии доказательности я задам в начале. Отделяй подтверждённое от гипотез, у каждого факта называй источник, противоречия отмечай отдельно. Не выдумывай ссылки: если источника нет, так и скажи.',
      },
      {
        key: 'trip',
        name: 'Поездка',
        stageTemplate: 'trip',
        systemPrompt: 'Ты — помощник в планировании поездки. Даты, состав участников и бюджет я назову в начале. Брони, адреса, время и суммы повторяй дословно и собирай в единый план. Напоминай о том, что ещё не забронировано.',
      },
    ],
  },
  edit: {
    // Правка своего сообщения (этап 22): хвост уходит из контекста — удалением
    // или пометкой, на выбор.
    action: 'Изменить',
    banner: 'Правим сообщение',
    tailDelete: 'Удалить ниже: {count}',
    tailKeep: 'Оставить ниже, но вне контекста',
    tailNone: 'Ниже ничего нет',
    keepHint: 'Останутся в переписке, но Петрович их не учитывает.',
    cancel: 'Отменить правку',
    send: 'Отправить заново',
    sending: 'Отправляем…',
    fieldLabel: 'Текст сообщения',
    removeImage: 'Убрать изображение',
    failed: 'Не получилось изменить сообщение. Повторите.',
    busy: 'Идёт ответ — сначала отмените генерацию.',
    sharedOnlyOwner: 'В общем чате править историю может только владелец чата.',
    excludedBadge: 'Вне контекста',
  },
  print: {
    // Распечатка чата (этап 21): экран печатного вида, печать и файл.
    title: 'Распечатка',
    back: 'Назад в чат',
    rangeLabel: 'Что печатаем',
    rangeAll: 'Весь чат',
    rangeLast: 'Последние {count} сообщений',
    rangePeriod: 'За период',
    rangeExchange: 'Один обмен',
    periodFrom: 'С',
    periodTo: 'По',
    densityLabel: 'Плотность',
    densityNormal: 'Обычная',
    densityCompact: 'Компактная',
    densityDraft: 'Черновик',
    densityHint: 'Компактная — мельче кегль, уже поля, реплики одного автора подряд идут одним блоком. Черновик — ещё и без обложки, картинки лентой миниатюр, длинные листинги сокращаются.',
    codeTrimmed: 'Листинг сокращён, ещё {count} строк.',
    paperHint: 'Ещё меньше бумаги: в диалоге печати включите двустороннюю печать и «2 страницы на листе».',
    withImages: 'С картинками',
    withSystem: 'С системными промптами',
    printAction: 'Печать',
    fileAction: 'Файл',
    preparing: 'Готовим документ…',
    empty: 'Печатать нечего: за выбранный период сообщений нет.',
    failed: 'Не получилось собрать документ. Повторите.',
    fileFailed: 'Не получилось сохранить файл.',
    fileSaved: 'Файл сохранён.',
    // В standalone-PWA на iOS системный диалог печати может не открыться —
    // тогда документ печатают из файла.
    printUnavailable: 'Печать из приложения недоступна — сохраните файл и напечатайте его.',
    roleUser: 'Вы',
    roleSystem: 'Системный промпт',
    coverParticipants: 'Участники',
    coverPeriod: 'Период',
    coverCount: 'Сообщений',
    coverPrinted: 'Напечатано',
    coverAnchor: 'Оригинал переписки в приложении',
    coverChat: 'Чат',
    truncated: 'История длиннее: напечатаны последние {count} сообщений.',
    imagesOmitted: 'Картинки не печатаются: {count}.',
    imageCaption: 'Изображение {index} из {total}',
    listTitle: 'Список',
    travelTitle: 'Путевой чат',
    travelPlaces: 'Места из Яндекс Карт',
    scanTitle: 'Сканы документов',
    notesTitle: 'Ссылки',
    // Пункты шторок чата.
    menuPrint: 'Печать и файл',
    menuMarkdown: 'Экспорт в Markdown',
    // В7 (1.27.6): печать и экспорт — в подменю меню чата.
    menuExportGroup: 'Экспорт и печать…',
    menuPrintExchange: 'Печать обмена',
    // Этапы (этап 23): свёрнутые этапы — конспектом или целиком; отчёт по проекту.
    stagesLabel: 'Свёрнутые этапы',
    stagesFolded: 'Конспектом',
    stagesFlat: 'Целиком',
    stageHeading: 'Этап {number}. {title}',
    stageHeadingUntitled: 'Этап {number}',
    stageRange: '{count} сообщений · {range}',
    sourceNote: 'Сообщение от {time}, {author}',
    menuReport: 'Отчёт по проекту',
    reportHiddenConfirm: 'Часть истории была до вашего приглашения и в отчёт не войдёт. Выгрузить?',
  },
  status: {
    // Строки из MQTT /status.message. Бэкенд пишет их по-английски и для логов
    // («Generation failed», «Chat is archived (read-only)»), а они доходили до
    // экрана как есть. Переводим по словарю; неизвестную латиницу прячем за общей
    // фразой, сырое уходит в console.
    unknown: 'Что-то пошло не так. Попробуйте ещё раз.',
    modelNotAllowed: 'Эта модель сейчас недоступна.',
    byMessage: {
      'Generation failed': 'Не получилось ответить. Попробуйте ещё раз.',
      'Request processing failed': 'Не получилось обработать запрос.',
      'Chat is archived (read-only)': 'Чат в архиве — писать в него нельзя.',
      'Chat not found': 'Чат удалён или недоступен.',
      'Access denied': 'Нет доступа к этому чату.',
      'Request not found': 'Запрос не найден.',
      'Request already completed': 'Запрос уже завершён.',
      'Failed to persist request': 'Не получилось сохранить сообщение.',
      'No user message to regenerate': 'Нечего перегенерировать.',
      'Regeneration is not available in shared chats': 'В общем чате перегенерация недоступна.',
      'Only the last answer can be regenerated': 'Заново можно ответить только на последний вопрос.',
      'Wait for the current answer to finish': 'Дождитесь, пока Петрович допишет ответ.',
      'Waiting for previous request to complete': 'Ждём предыдущий ответ…',
      'Restored after restart': 'Возвращаем запрос в работу…',
      'Resuming after restart': 'Возвращаем запрос в работу…',
      'Duplicate requestId ignored': 'Сообщение уже отправлено.',
      'Duplicate requestId; returning existing response': 'Ответ уже получен.',
      'Cancelled by user': 'Отменено.',
      Delivered: 'Доставлено.',
      'Context reset': 'Контекст очищен.',
      'Generation complete': 'Готово.',
      // Этап 25.2: ни одно звено цепочки не ответило — запрос ждёт до 5 минут.
      'Waiting for brain': 'Жду связи с мозгом…',
    },
  },
};

// Статус ожидания «мозга» (этап 25.2) — строка протокола backend.
export const WAITING_FOR_BRAIN = 'Waiting for brain';

// Пометка недописанного ответа (1.27.0) — в ленте, экспорте и печати одна и та же.
export function stopReasonLabel(stopReason) {
  if (stopReason === 'error') {
    return TEXT.chat.interruptedBadge;
  }
  return stopReason === 'cancelled' ? TEXT.chat.stoppedBadge : '';
}

// Пометка под ответом резервного звена: «ответил резерв: z.ai · glm-5.3».
export function fallbackLabel(model) {
  const [provider, ...rest] = String(model || '').split(':');
  const name = rest.join(':') || provider;
  const providerName = TEXT.brain.providerNames[provider] || provider;
  return `${TEXT.brain.fallbackBadge} ${providerName} · ${name}`;
}

// Латиница без кириллицы — техническая строка бэкенда. Русские сообщения (их шлёт
// демон дачи: «проверяет дом… (read_sensors)») проходят как есть.
const CYRILLIC = /[\u0400-\u04FF]/;
const MODEL_NOT_ALLOWED = /^(Effective model|Model) '.*' is not allowed$/;

export function describeStatusMessage(message) {
  const raw = typeof message === 'string' ? message.trim() : '';
  if (!raw) {
    return '';
  }
  const known = TEXT.status.byMessage[raw];
  if (known) {
    return known;
  }
  if (MODEL_NOT_ALLOWED.test(raw)) {
    return TEXT.status.modelNotAllowed;
  }
  if (CYRILLIC.test(raw)) {
    return raw;
  }
  console.warn('Untranslated status message from backend:', raw);
  return TEXT.status.unknown;
}
